<div class="slider-container">
    <div class="popover-header">{{title}}</div>
    <div class="popover-container">
        <kve-input-filter 
            placeholder="Search items..."
            (filterChange)="onBasicFilter($event)">
        </kve-input-filter>
        <!-- <div class="filter-container">
            <input 
              type="text" 
              [formControl]="filterControl"
              [placeholder]="placeholder"
              class="filter-input"
              (filterChange)="onBasicFilter($event)">
            <button *ngIf="filterControl.value" 
                    (click)="clearFilter()" 
                    class="clear-btn">
              ×
            </button>
          </div> -->
          <ng-container *ngIf="filteredItems.length > 0;else unfiltered">
            <div *ngFor="let fontFam of filteredItems" [ngStyle]="{'font-family':''+fontFam.value+''}" class="pop-select" (click)="onSelectFontFam(fontFam)">
                <div class="h6">{{(content?.text.length>15)? (content?.text | slice:0:15)+'...':(content?.text)}}</div>
                <div class="font-fam-preview">{{fontFam.value}}</div>
            </div>
          </ng-container>
          <ng-template #unfiltered>
            <div *ngFor="let fontFam of fontFams" [ngStyle]="{'font-family':''+fontFam.value+''}" class="pop-select" (click)="onSelectFontFam(fontFam)">
                <div>{{(content?.text.length>15)? (content?.text | slice:0:15)+'...':(content?.text)}}</div>
                <div class="h6 font-fam-preview">{{fontFam.value}}</div>
            </div>
          </ng-template>
        
    </div>
    <!-- <ng-container *ngIf="optionsSet">
        <div class="custom-slider">
            <ngx-slider
                [(value)]="value"
                [options]="options"
                (userChangeStart)="onUserChangeStart($event)"
                (userChange)="onUserChange($event)"
                (userChangeEnd)="onUserChangeEnd($event)">
            </ngx-slider>
        </div>
    </ng-container> -->
    <div class="popover-footer">
        <button nbButton size="tiny" (click)="onSubmit()">Apply</button>
    </div>
</div>
